import {Dispatchable} from "../../stem-core/src/base/Dispatcher";
import {getQueryParam} from "../UtilsLib";


// TODO @auth this should be removed
class SocialAuthService extends Dispatchable {
    constructor() {
        super();
        this.merchantId = getQueryParam("clientId");
    }

    setMerchantId(merchantId) {
        this.merchantId = merchantId;
        this.dispatch("update");
    }
}

export const socialAuthService = new SocialAuthService();
